import apiClient from "./apiClient";

export const getAllPermissionsApi = async (user_type_id: number) => {
    try {
        const response = await apiClient.get(`/api/permission/${user_type_id}`);
        
        if (response.status === 200) {
          return { status: true, body: response.data };
        } else {
          return { status: false, error: 'failed' };
        }
  
      } catch (error: any) {
        // Handle error (display error message, log, etc.)
        return { status: false, error: 'An error occurred. Please try again later.' };
      }
  }


  export const getAllNewPermissionsApi = async () => {
    try {
        const response = await apiClient.get(`/api/site-bar-menu-list`);
        
        if (response.status === 200) {
          return { status: true, body: response.data };
        } else {
          return { status: false, error: 'failed' };
        }
  
      } catch (error: any) {
        // Handle error (display error message, log, etc.)
        return { status: false, error: 'An error occurred. Please try again later.' };
      }
  }